import { useEffect, useState, type ReactNode } from 'react'
import { useLocation } from 'react-router-dom'

import { documentTitle, PageTitleContext, routeTitle, type PageTitleOverride } from '../lib/pageTitle'

// Ustawia document.title dla KAŻDEJ trasy (także /print — tytuł PDF-u): konkret ze
// strony (usePageTitle), jeśli dotyczy bieżącej ścieżki, inaczej nazwa z mapy tras.
export function PageTitleProvider({ children }: { children: ReactNode }) {
  const { pathname } = useLocation()
  const [override, setOverride] = useState<PageTitleOverride | null>(null)
  const page = override?.path === pathname ? override.title : routeTitle(pathname)

  useEffect(() => {
    document.title = documentTitle(page)
  }, [page])

  return <PageTitleContext.Provider value={setOverride}>{children}</PageTitleContext.Provider>
}
